import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Certification, Education, Experience } from "../../../../Types/Resume";

interface ClientProfileCreationState {
    userId: string | undefined;
    step: number;
    company: string | undefined;
    country: string | undefined;
    primaryLanguage: string | undefined;
    secondaryLanguage: string | undefined;
    summary: string | undefined;
    nextDisabled: boolean;
    profilePicture: File | undefined;
}

const initialState: ClientProfileCreationState = {
    userId: undefined,
    step: 1,
    company: undefined,
    country: undefined,
    primaryLanguage: undefined,
    secondaryLanguage: undefined,
    summary: undefined,
    nextDisabled: true,
    profilePicture: undefined
}

export const clientProfileCreationSlice = createSlice({
    name: 'ClientProfileCreation',
    initialState,
    reducers: {
        setProfileCreationUserId(state, action: PayloadAction<ClientProfileCreationState["userId"]>){
            state.userId = action.payload;
        },
        initializeClientProfileCreation(state, action: PayloadAction<ClientProfileCreationState>){
            state = {...state, ...action.payload};
        },
        setStep(state, action: PayloadAction<ClientProfileCreationState["step"]>){
            state.step = action.payload;
        },
        setCompany(state, action: PayloadAction<ClientProfileCreationState["company"]>){
            state.company = action.payload;
        },
        setCountry(state, action: PayloadAction<ClientProfileCreationState["country"]>){
            state.country = action.payload;
        },
        setPrimaryLanguage(state, action: PayloadAction<ClientProfileCreationState["primaryLanguage"]>){
            state.primaryLanguage = action.payload;
        },
        setSecondaryLanguage(state, action: PayloadAction<ClientProfileCreationState["secondaryLanguage"]>){
            state.secondaryLanguage = action.payload;
        },
        setSummary(state, action: PayloadAction<ClientProfileCreationState["summary"]>){
            state.summary = action.payload;
        },
        setNextDisabled(state, action: PayloadAction<ClientProfileCreationState["nextDisabled"]>){
            state.nextDisabled = action.payload;
        },
        setClientProfilePicture(state, action: PayloadAction<ClientProfileCreationState["profilePicture"]>){
            state.profilePicture = action.payload;
        },
        resetState: () => initialState
    }
})

export const {
    initializeClientProfileCreation,
    setSummary,
    setPrimaryLanguage,
    setCompany,
    setCountry,
    setSecondaryLanguage,
    setStep,
    setNextDisabled,
    resetState,
    setProfileCreationUserId,
    setClientProfilePicture
} = clientProfileCreationSlice.actions

export default clientProfileCreationSlice.reducer

